import {createContext} from 'react';
import noop from '@tinkoff/utils/function/noop';

import {Locations} from 'utils/constants';
import {type EventParametersMap} from '@time-webkit/statist/src/methods';

export type TPostContext = {
    location: keyof typeof Locations;
    handlePopupOpened?: () => void;
    onLogPostAction: (
        action: EventParametersMap['app.postAction']['action'],
        inputType: EventParametersMap['app.postAction']['inputType'],
    ) => void;
}

const PostContext = createContext<TPostContext>({

    // Post component event handler that should be
    // called when any child component opens/closes a
    // popup type component.
    handlePopupOpened: undefined,
    location: Locations.CENTER,
    onLogPostAction: noop,

});

export default PostContext;
